import { render, staticRenderFns } from "./PostImages.vue?vue&type=template&id=8a0f2b60&scoped=true&"
import script from "./PostImages.vue?vue&type=script&lang=js&"
export * from "./PostImages.vue?vue&type=script&lang=js&"
import style0 from "./PostImages.vue?vue&type=style&index=0&id=8a0f2b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0f2b60",
  null
  
)

export default component.exports